define("settings/templates/subscription/billing/email", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-expect-error: Shared::Modal not typesafe yet }}
  <Shared::Modal @close={{perform this.handleClose}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "account.subscription.billing.email.title"}} class="u--p__b" />
      {{! @glint-expect-error: Shared::Modal not typesafe yet }}
      <ModalForm
        @cancel={{modal.close}}
        @isDisabled={{this.isSaveDisabled}}
        @runningText={{t "shared_words.saving"}}
        @task={{task this.handleSubmit}}
        as |form|
      >
        <modal.card-body>
          <form.input @qaClassInputLabel="qa--billingEmail__title" as |uniqueId|>
  
            {{! @glint-expect-error: canonicalBillingEmail changeset typed as unknown}}
            <Input
              @type="email"
              @value={{this.emailChangeset.canonicalBillingEmail}}
              autocomplete="billing email"
              class="o--form__input
                {{if this.isEditDisabled 'u--mute'}}
                {{if this.emailChangeset.error.canonicalBillingEmail 'o--form__input--hasError'}}
                qa--billingEmail__input"
              disabled={{this.isEditDisabled}}
              id={{uniqueId}}
              placeholder={{t "account.subscription.billing.email.placeholder"}}
            />
            {{#if this.emailChangeset.error.canonicalBillingEmail}}
              <span class="o--form__helpText is--error u--m__tb__xs">
                {{t "account.subscription.billing.email.error"}}
              </span>
            {{/if}}
          </form.input>
        </modal.card-body>
        <modal.card-footer>
          <form.footer @submitButtonText={{t "shared_words.save"}} />
        </modal.card-footer>
      </ModalForm>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "DUIGpfQc",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0,[\"handleClose\"]]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b\"]],[[\"@title\"],[[28,[37,2],[\"account.subscription.billing.email.title\"],null]]],null],[1,\"\\n\"],[1,\"    \"],[8,[39,3],null,[[\"@cancel\",\"@isDisabled\",\"@runningText\",\"@task\"],[[30,1,[\"close\"]],[30,0,[\"isSaveDisabled\"]],[28,[37,2],[\"shared_words.saving\"],null],[28,[37,4],[[30,0,[\"handleSubmit\"]]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"input\"]],null,[[\"@qaClassInputLabel\"],[\"qa--billingEmail__title\"]],[[\"default\"],[[[[1,\"\\n\\n\"],[1,\"          \"],[8,[39,5],[[24,\"autocomplete\",\"billing email\"],[16,0,[29,[\"o--form__input\\n              \",[52,[30,0,[\"isEditDisabled\"]],\"u--mute\"],\"\\n              \",[52,[30,0,[\"emailChangeset\",\"error\",\"canonicalBillingEmail\"]],\"o--form__input--hasError\"],\"\\n              qa--billingEmail__input\"]]],[16,\"disabled\",[30,0,[\"isEditDisabled\"]]],[16,1,[30,3]],[16,\"placeholder\",[28,[37,2],[\"account.subscription.billing.email.placeholder\"],null]]],[[\"@type\",\"@value\"],[\"email\",[30,0,[\"emailChangeset\",\"canonicalBillingEmail\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"emailChangeset\",\"error\",\"canonicalBillingEmail\"]],[[[1,\"            \"],[10,1],[14,0,\"o--form__helpText is--error u--m__tb__xs\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"account.subscription.billing.email.error\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"]],[3]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"footer\"]],null,[[\"@submitButtonText\"],[[28,[37,2],[\"shared_words.save\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[2]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"form\",\"uniqueId\"],false,[\"shared/modal\",\"perform\",\"t\",\"modal-form\",\"task\",\"input\",\"if\"]]",
    "moduleName": "settings/templates/subscription/billing/email.hbs",
    "isStrictMode": false
  });
});